<template lang="html">
  <router-link :to="link" class="draft-card card">
    <template v-if="draft">
      <h3>{{ draft.name }} <span v-if="draft.commissioner">(Commissioner)</span></h3>
      <h5>{{ draft.teamName }}</h5>

      <div><b>Status:</b> {{ draft.status }}</div>
      <div><b>Rounds:</b> {{ draft.rounds }}</div>
      <div><b>Teams:</b> {{ draft.teams }}</div>
      <div><b>Type:</b> {{ draft.type }}</div>
    </template>

    <div to="/draft/create" class="new-draft" v-else>
      <i class="fas fa-plus"></i>

      <h4>Create a new draft</h4>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    draft: Object,
  },

  computed: {
    link() {
      return this.draft ? `/draft/${this.draft.id}/settings` : '/draft/create';
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .draft-card {
    display: flex;
    flex-direction: column;
    min-height: px-to-rem(240px);
    color: $black-color;
  }

  .new-draft {
    text-align: center;
    color: $primary-color;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h4 {
      margin-top: $gp;
    }

    .fa-plus {
      font-size: px-to-rem(30px);
    }
  }
</style>
